(function () {
  'use strict';

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function selectedOptions() {
    var out = [];
    document.querySelectorAll('variant-picker input:checked').forEach(function (input) {
      var label = input.closest('label');
      if (!label && input.id) label = document.querySelector('label[for="' + input.id + '"]');
      var text = label ? label.textContent.trim() : (input.value || '').trim();
      if (text) out.push(text);
    });
    return out;
  }

  function addToCartButton(box) {
    var scope = (box && box.closest('.product-info')) || document;
    var candidates = Array.prototype.slice.call(scope.querySelectorAll('button[type="submit"]'));
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].closest('[data-vherso-notify]')) return candidates[i];
    }
    return null;
  }



  /* --------------------------------------------------------------------
     Lingua in base al browser: alla prima visita porta chi non e' italiano
     sulla versione tradotta. La valuta la gestiscono gia' i Mercati.
     -------------------------------------------------------------------- */
  var LOCALES = ['en', 'de', 'fr', 'es', 'sv', 'no', 'tr', 'ja', 'ar'];

  function localeRedirect() {
    try {
      var path = window.location.pathname || '/';
      if (new RegExp('^/(' + LOCALES.join('|') + ')(/|$)').test(path)) return;
      if (document.cookie.indexOf('vherso_lang=') > -1) return;

      var lang = (navigator.language || navigator.userLanguage || '').slice(0, 2).toLowerCase();
      document.cookie = 'vherso_lang=1;path=/;max-age=31536000;SameSite=Lax';

      if (!lang || lang === 'it') return;
      if (LOCALES.indexOf(lang) === -1) lang = 'en';

      window.location.replace('/' + lang + path + window.location.search + window.location.hash);
    } catch (e) { /* niente */ }
  }


  /* --------------------------------------------------------------------
     Iscrizioni newsletter -> Klaviyo (lista "Elenco e-mail")
     Il form nativo del tema continua a funzionare: qui in piu' mandiamo
     il contatto a Klaviyo cosi' parte subito il flow di benvenuto.
     Mandiamo anche Lingua e Paese: servono al flow per scrivere
     nella lingua giusta (fallback inglese).
     -------------------------------------------------------------------- */
  var KLAVIYO_COMPANY = 'XcBTsJ';
  var KLAVIYO_LIST = 'UCvGFc';

  var SUPPORTED_LANGS = ['it', 'en', 'es', 'de', 'fr'];

  function siteLang() {
    var l = '';
    try { if (window.Shopify && Shopify.locale) l = String(Shopify.locale); } catch (e) { l = ''; }
    if (!l) l = document.documentElement.getAttribute('lang') || '';
    if (!l) l = navigator.language || '';
    l = l.toLowerCase().split('-')[0];
    if (SUPPORTED_LANGS.indexOf(l) < 0) l = 'en';
    return l;
  }

  function siteCountry() {
    try { if (window.Shopify && Shopify.country) return String(Shopify.country).toUpperCase(); } catch (e) { return ''; }
    return '';
  }

  function klaviyoSubscribe(email, source) {
    if (!email || email.indexOf('@') < 1) return;
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
        method: 'POST',
        keepalive: true,
        mode: 'cors',
        headers: { 'content-type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source || 'Sito VHERSO',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      'Origine iscrizione': source || 'Sito VHERSO',
                      'Lingua': siteLang(),
                      'Paese': siteCountry()
                    }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
          }
        })
      }).catch(function () { /* niente */ });
    } catch (e) { /* niente */ }
  }

  function initKlaviyoForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var field = form.querySelector('input[type="email"]');
      if (!field || !field.value) return;

      var source = 'Sito VHERSO';
      if (form.closest('[data-vherso-notify]')) {
        source = 'Avviso taglia esaurita';
      } else if (form.closest('.newsletter-popup')) {
        source = 'Pop-up sito';
      } else if (form.closest('footer, .footer')) {
        source = 'Footer sito';
      } else {
        source = 'Sezione newsletter';
      }

      klaviyoSubscribe(field.value.trim(), source);
    }, true);
  }

  function initGalleryArrows() {
    document.querySelectorAll('product-gallery').forEach(function (gallery) {
      var track = gallery.querySelector('.product-gallery__carousel');
      if (!track) return;
      if (gallery.querySelector('.vherso-arrow')) return;
      if (track.querySelectorAll('.product-gallery__media').length < 2) return;

      ['prev', 'next'].forEach(function (dir) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'vherso-arrow vherso-arrow--' + dir;
        button.setAttribute('aria-label', dir === 'prev' ? 'Immagine precedente' : 'Immagine successiva');
        button.innerHTML = dir === 'prev'
          ? '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 4 7 12l8 8"/></svg>'
          : '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4l8 8-8 8"/></svg>';
        button.addEventListener('click', function () {
          var step = track.clientWidth || 400;
          track.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
        });
        gallery.appendChild(button);
      });

      gallery.classList.add('vherso-gallery--arrows');
    });
  }

  function syncNotify() {
    var boxes = document.querySelectorAll('[data-vherso-notify]');
    if (!boxes.length) return;

    var button = addToCartButton(boxes[0]);
    var soldOut = false;
    if (button) {
      var label = (button.textContent || '').toLowerCase();
      soldOut = button.disabled
        || button.getAttribute('aria-disabled') === 'true'
        || label.indexOf('esaurit') > -1
        || label.indexOf('sold out') > -1
        || label.indexOf('agotado') > -1
        || label.indexOf('ausverkauft') > -1
        || label.indexOf('rupture') > -1;
    }

    var title = document.querySelector('h1');
    var options = selectedOptions();
    var reference = (title ? title.textContent.trim() : '')
      + (options.length ? ' — ' + options.join(' / ') : '');

    for (var i = 0; i < boxes.length; i++) {
      boxes[i].hidden = !soldOut;
      var field = boxes[i].querySelector('[data-vherso-product]');
      if (field) field.value = reference;
    }
  }

  function fixSwatches() {
    var MAP = {
      'light blue': '#8FB8DE',
      'wine red': '#6E2639',
      'navy blue': '#1B2A4A',
      'off white': '#F2EFE9',
      'sky blue': '#87CEEB'
    };
    var swatches = document.querySelectorAll('.color-swatch');
    for (var i = 0; i < swatches.length; i++) {
      if (swatches[i].hasAttribute('data-vherso-swatch')) continue;
      var raw = swatches[i].getAttribute('style') || '';
      var match = raw.match(/linear-gradient\(to right,\s*([^,\)]+)/);
      if (!match) continue;
      var name = match[1].trim().toLowerCase();
      var hex = MAP[name];
      if (!hex) continue;
      swatches[i].setAttribute('data-vherso-swatch', name);
      swatches[i].style.setProperty('--swatch-background', 'linear-gradient(to right, ' + hex + ', ' + hex + ')');
    }
  }

  function boot() {
    localeRedirect();
    initKlaviyoForms();

    var refresh = debounce(function () {
      initGalleryArrows();
      fixSwatches();
      syncNotify();
    }, 90);

    initGalleryArrows();
    fixSwatches();
    syncNotify();

    document.addEventListener('change', refresh);
    document.addEventListener('click', refresh);
    new MutationObserver(refresh).observe(document.documentElement, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
